export default __webpack_public_path__ + "static/media/imageColorization2Low.6c857231.png";